// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__c9qjB","section":"styles_section__QYL-L"};